import React from "react";
import TextInput from "../TextInput";

const NewTrackCategoryModal = ({
  newCategory,
  setNewCategory,
  insertCategory,
}) => {
  let orderError, descriptionError;

  if (newCategory.errors) {
    if (newCategory.errors.categoryOrder)
      orderError = newCategory.errors.categoryOrder;
    if (newCategory.errors.description)
      descriptionError = newCategory.errors.description;
  }

  //Onchange New Track Category
  const onChangeNewCategory = (e) => {
    const { name, value } = e.target;
    let newValue = value;

    if (name === "CategoryOrder") {
      if (value === "") {
        setNewCategory({
          ...newCategory,
          [name]: "",
          Change: true,
        });
        return;
      }

      if (!/^\d+$/.test(value)) return;

      const numberValue = parseInt(value, 10);

      if (numberValue < 0 || numberValue > 255) return;

      newValue = numberValue;
    }

    if (name === "LastModificationUser") {
      newValue = parseInt(value, 10) || 0;
    }

    setNewCategory({
      ...newCategory,
      [name]: newValue,
      Change: true,
    });
  };

  //Clean Inputs New Track Modal
  const cleanInputs = () => {
    setNewCategory({
      CategoryOrder: 0,
      Description: "",
    });
  };

  return (
    <>
      <div
        className="modal fade"
        id="newTrackCategoryModal"
        role="dialog"
        aria-hidden="false"
        data-keyboard="false"
        data-backdrop="static"
        style={{
          backgroundColor: "rgba(0, 0, 0, 0.2)",
          zIndex: 1051,
        }}
      >
        <div className="modal-dialog modal-xs" style={{ margin: "4rem auto" }}>
          <div className="modal-content">
            <div
              className="modal-header"
              style={{ backgroundColor: "#5b6671", color: "#fff" }}
            >
              <h5 className="modal-title" id="newTrackCategoryModal">
                New Category
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                onClick={() => cleanInputs()}
              >
                &times;
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-sm-12">
                  <form autoComplete="off">
                    {/* Order */}
                    <div className="form-group">
                      <TextInput
                        id="CategoryOrder"
                        label="Order"
                        name="CategoryOrder"
                        value={newCategory.CategoryOrder ?? ""}
                        onChange={onChangeNewCategory}
                        error={orderError}
                        changeColor={true}
                        maxLength={3}
                      />
                    </div>
                    {/* Category Description */}
                    <div className="form-group">
                      <TextInput
                        id="Description"
                        label="Description"
                        name="Description"
                        type="text"
                        onChange={(e) => onChangeNewCategory(e)}
                        error={descriptionError}
                        value={newCategory.Description || ""}
                        changeColor={true}
                        maxLength={50}
                      />
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-success"
                onClick={() => insertCategory(newCategory)}
              >
                Save
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
                onClick={() => cleanInputs()}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewTrackCategoryModal;
